import { FormRuleConditionType } from "../constants";

export const getSupportedRuleConditionTypes = ({
    isClassesEnabled,
}: {
    isClassesEnabled: boolean;
}): FormRuleConditionType[] => [
    FormRuleConditionType.CATEGORY,
    FormRuleConditionType.AMOUNT,
    FormRuleConditionType.BANK_DESCRIPTION,
    FormRuleConditionType.ACCOUNT,
    FormRuleConditionType.COUNTERPARTY,
    FormRuleConditionType.DATE,
    ...(isClassesEnabled ? [FormRuleConditionType.CLASS] : []),
    FormRuleConditionType.SIMILAR_TO,
];
